module.exports = __webpack_public_path__ + "static/img/carousel.aeb1357b.png";